import React from "react";

import { IgListItemButton } from "@intelligems/ig-theme";
import {
  ChannelType,
  DeviceType,
  StatSigViewType,
  VisitorType,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { Visitor } from "../AudienceFilters/Visitor";

interface VisitorTypeFilterProps {
  onStringFilterChange: (
    newValue: DeviceType | VisitorType | ChannelType | StatSigViewType,
    filterKey: "statSigView" | "deviceType" | "channelType" | "visitorType"
  ) => void;
  visitorType?: VisitorType | null;
}

export const VisitorTypeFilter = ({
  visitorType,
  onStringFilterChange,
}: VisitorTypeFilterProps) => {
  return <Visitor visitorType={visitorType} onClick={onStringFilterChange} />;
};
